/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : projectConfigAPI.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
/**
 * @author Abdul Rahim M-abdul@au79consulting.com
 * @date 20-07-2024
 * @description  Project Config API documentation Apis
 */

import actionType from "../actionTypes";
const projectConfigAPI = {
  get_project: {
    api_name: "/PCM/project/details",
    https_method: "GET",
    action_type: actionType.GET_PROJECT,
    description: "Get the Admin Settings",
  },
  // get_project_recreate: {
  //   api_name: "/PCM/project/details",
  //   https_method: "GET",
  //   action_type: actionType.GET_RECREATE_PROJECT,
  //   description: "Get the Admin Settings",
  // },
  get_project_recreate: {
    api_name: "/RCS/project/get",
    https_method: "GET",
    action_type: actionType.GET_RECREATE_PROJECT,
    description: "Get Parent project details to recreate project",
  },

  add_project_recreate: {
    api_name: "/RCS/project/recreate",
    https_method: "POST",
    action_type: "",
    description: "Get Parent project details to recreate project",
  },

  add_project: {
    api_name: "/PCM/project/create",
    https_method: "POST",
    action_type: actionType.ADD_PROJECT,
    description: "",
  },
  update_project: {
    api_name: "/PCM/project/details",
    https_method: "PUT",
    action_type: actionType.UPDATE_PROJECT,
    description: "Update Project",
  },
  update_project_milestones: {
    api_name: "/PCM/project/details",
    https_method: "PUT",
    action_type: actionType.UPDATE_PROJECT,
    description: "Update Project Milestones",
  },
  update_project_status: {
    api_name: "/PCM/project/status",
    https_method: "PUT",
    action_type: actionType.UPDATE_PROJECT_STATUS,
    description: "Update Project Status",
  },
  // Change logs
  get_project_change_logs: {
    api_name: "/PCM/project/change-logs",
    https_method: "GET",
    action_type: actionType.GET_PROJECT_CHANGE_LOGS,
    description: "",
  },

  get_users_list: {
    api_name: "/UCM/user/all",
    https_method: "GET",
    action_type: actionType.GET_USERS_DETAILS_LIST,
    description: "",
  },
  get_variant_change_logs: {
    api_name: "/PCM/project/variant/change-logs",
    https_method: "GET",
    action_type: actionType.GET_VARIANT_CHANGE_LOGS,
    description: "",
  },

  //Variant Details
  get_variant_details: {
    api_name: "/PCM/project/variants",
    https_method: "GET",
    action_type: actionType.GET_VARIANTS,
    description: "Get the Variant Details",
  },
  get_homologation_details: {
    api_name: "/PCM/project/getHomologationDetails",
    https_method: "GET",
    action_type: "",
    description: "Get homologation details by project",
  },
  get_homologation_action_details: {
    api_name: "/PCM/project/getHomologationActionDetails",
    https_method: "GET",
    action_type: "",
    description: "Get homologation action details by project and variant",
  },
  homologation_action_confirm: {
    api_name: "/PCM/project/homologationActionConfirm",
    https_method: "PUT",
    action_type: "",
    description: "Confirm a homologation action",
  },
  update_homologation_vehicle_count: {
    api_name: "/PCM/project/updateHomologationVehicleCount",
    https_method: "PUT",
    action_type: "",
    description: "Update a homologation vehicle count",
  },
  get_variant_details_recreation: {
    api_name: "/PCM/project/variants",
    https_method: "GET",
    action_type: actionType.GET_VARIANTS_RECREATION,
    description: "Get the Variant Details Recreation",
  },
  add_variant: {
    api_name: "/PCM/project/variant",
    https_method: "POST",
    action_type: actionType.ADD_VARIANTS,
    description: "Add the Variant Details",
  },
  add_recreated_variant: {
    api_name: "/RCS/variant/recreate",
    https_method: "POST",
    action_type: actionType.ADD_VARIANTS,
    description: "Add the Variant Details",
  },
  update_variant_milestones: {
    api_name: "/PCM/project/variant/milestones",
    https_method: "PUT",
    action_type: "",
    description: "Update Variant Milestones",
  },
  update_vehicle_status: {
    api_name: "/PCM/project/variant/status",
    https_method: "PUT",
    action_type: actionType.UPDATE_VS_VARIANT,
    description: "Update the VS Variant Details",
  },
  update_vehicle_function: {
    api_name: "/PCM/project/variant/vf",
    https_method: "PUT",
    action_type: actionType.UPDATE_VS_VEHICLE_FUNCTION,
    description: "Update the VF Variant Details",
  },
  update_vehicle_components: {
    api_name: "/PCM/project/variant/components",
    https_method: "PUT",
    action_type: actionType.UPDATE_VS_VEHICLE_COMPONENTS,
    description: "Update the VC Variant Details",
  },
  update_variant_color: {
    api_name: "/PCM/project/variant/color_code",
    https_method: "PUT",
    action_type: actionType.UPDATE_VARIANT_COLOR,
    description: "Update the variant color",
  },
  // Project
  get_projects_main: {
    api_name: "/PCM/project/details",
    https_method: "GET",
    action_type: actionType.GET_PROJECTS_MAIN,
    description: "Get projects details",
  },
  // Variant
  get_variants_main: {
    api_name: "/PCM/project/variants",
    https_method: "GET",
    action_type: actionType.GET_VARIANTS_MAIN,
    description: "Get variants details",
  },
  get_variants_for_recreation: {
    api_name: "/RCS/variant/get",
    https_method: "GET",
    action_type: "",
    description: "Get variants details for recreated projects",
  },
};

export default projectConfigAPI;
